export const CLIENT_MAX_RESPONSE_TIME = 40 * 1000;
export const CLIENT_RECONNECT_DELAY = 10 * 1000;

export const SERVER_PING_DATA = "server-ping";
export const SERVER_NEXT_PING_DELAY = 15 * 1000;
export const SERVER_MAX_RESPONSE_TIME = 40 * 1000;
export const SERVER_CLEANUP_INTERVAL = 1 * 60 * 1000;
